import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import ShopListItemEtaBox from './shop_list_item_eta_box';
import ShopListItemClosedBox from './shop_list_item_closed_box';
import ShopListItemBody from './shop_list_item_body';
import ShopListItemBodyNameOnly from './shop_list_item_body_name_only';
import ShopListItemMaintenanceBox from "./shop_list_item_maintenance_box";
import PropTypes from 'prop-types'; // ES6
import {inject} from 'mobx-react';

const shopListItemLogoWrapper = {
	"width": "100%",
    "height": "100%",
    "borderRadius": "50% 0 0 50%",
    "backgroundColor": "white"
};

const shopListItemLogo = {
    "width": "100%",
    "height": "100%",
    "borderRadius": "50%"
};

const extraImageWrapper = {
    "width": "90%",
    "height": "90%",
    "borderRadius": "50%",
    "margin": "5%",
};

const default3PartWidth = {
    image: "18.5%",
    body: "63.5%",
    status: "18%"
};

const determineEtabox = function (shop) {
    //display the correct left side box options:[eta, closed, under maintenance]
    if(!shop.is_open) {
        return <ShopListItemClosedBox shop={shop} />
    } else if(shop.is_hw_um) {
        return <ShopListItemMaintenanceBox shop={shop} />
    } else {
        return <ShopListItemEtaBox shop={shop} />;
    }
};

const determineShopLineHeight = function(shop) {
    //to display the queue or just the name on the shop body
    if (shop.queue_length === 0 || !shop.is_open) {
        return <ShopListItemBodyNameOnly shop={shop}/>;
    } else {
        return <ShopListItemBody shop={shop}/>;
    }
};

@inject('RootStore')
export default class ShopListItem extends Component {

    componentDidUpdate() {
        const hallStore = this.props.RootStore.hallStore;
        const clientHeight = this.divElement.clientHeight;
        if(clientHeight && clientHeight !== hallStore.shopItemHeight) {
           hallStore.setShopItemHeight(clientHeight);
        }
    }

    render() {
        const mainFlexWidths = this.props.componentWidths ? this.props.componentWidths : default3PartWidth;
        const {shop} = this.props;
        const shopItemHeight = this.props.RootStore.hallStore.shopItemHeight;
        const etaBox = determineEtabox(shop);
        const shopBody = determineShopLineHeight(shop);
        return (
            <div style={{height:"100%", width:"100%"}} ref={ (divElement) => this.divElement = divElement}>
                <Flexbox height="100%" width="100%" flexDirection="row">
                   <Flexbox width={shopItemHeight? `${shopItemHeight}px`: mainFlexWidths.image}>
                       <div style={shopListItemLogoWrapper}>
                           <div style={extraImageWrapper}>
                           <img src={shop.image}  alt=""
                            style={shopListItemLogo}/>
                           </div>
                       </div>
                   </Flexbox>
                   <Flexbox style={{background: "white"}} width={mainFlexWidths.body}>
                       {shopBody}
                   </Flexbox>
                   <Flexbox width={shopItemHeight? `${shopItemHeight}px`: mainFlexWidths.status} height="100%">
                       {etaBox}
                   </Flexbox>

               </Flexbox>
            </div>
        );
    }
}

ShopListItem.propTypes = {
  shop: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/shop_list_item/shop_list_item.jsx